import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../ui/Dialog';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import NavList from '../elements/NavList';
import { debounce } from 'lodash';

const SharedModlalToAddItemFromList = ({
  visible,
  onClose,
  data,
  submit,
  title,
  onSearch,
  currentList = [],
  hasMore,
  fetchMore,
}) => {
  const [active, setActive] = useState(null);
  const prepareData = () =>
    (data || [])
      .map((item) => ({ ...item, text: item.title }))
      .filter((item) => !currentList.includes(item.id));

  const makeActive = (id) => {
    setActive(id);
  };

  const debounceSearch = debounce((e) => {
    onSearch(e);
  }, 500);

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Input
            placeholder="Vyhledat"
            data-testid="shared-modal-search-input"
            onChange={debounceSearch}
            className="h-7.5"
          />
          <NavList
            data={prepareData()}
            makeActive={makeActive}
            active={active}
            hasMore={hasMore}
            fetchMoreData={fetchMore}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            data-testid="shared-modal-close-btn"
            variant="outline"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="shared-modal-submit-btn"
            disabled={!active}
            onClick={() => submit(active)}
          >
            Přidat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SharedModlalToAddItemFromList;
